module.exports = __webpack_public_path__ + "static/img/unit-match.a38055a0.png";